<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal" v-if="!noQuota">
    <span class="el-dialog__title" data-qa="Dialog-CreateNotificationAdd-Title" slot="header">{{ $t('notificationsCreateTitleAdd') }}</span>
    <el-form ref="data" :model="data" id="createForm" @submit.native.prevent="createNotification" enctype="multipart/form-data" label-position="left">
      <el-form-item
        :error="errors.has('familyName') ? errors.first('familyName') : ''"
        :label="$t('notificationsCreateInputFamilyNameLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('familyName')"
        data-qa="Dialog-CreateNotificationFamilyName-Item"
      >
        <el-select
          :placeholder="$t('notificationsCreateInputFamilyNamePlaceholder')"
          :data-vv-as="$t('notificationsCreateInputFamilyNameLabel')"
          class="full-width"
          data-qa="Dialog-CreateNotificationFamilyName-Select"
          multiple
          name="familyName"
          required
          v-model="data.familyNames"
          v-validate="{ rules: { required: true } }"
        >
          <el-option
            :key="name"
            :label="name"
            :value="name"
            v-for="name in familyNames"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label-width="labelWidth"
        class="column-describe"
        data-qa="Dialog-CreateNotificationFamilyName-Description"
      >
        <div class="fit-line-height">
          <i>{{ $t('notificationsCreateInputFamilyNameHint') }}</i>
        </div>
      </el-form-item>
      <el-form-item
        :error="errors.has('ruleType') ? errors.first('ruleType') : ''"
        :label="$t('notificationsCreateInputRuleTypeLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('ruleType')"
        data-qa="Dialog-CreateNotificationRuleType-Item"
      >
        <el-select
          :placeholder="$t('notificationsCreateInputRuleTypePlaceholder')"
          :data-vv-as="$t('notificationsCreateInputRuleTypePlaceholder')"
          class="full-width"
          data-qa="Dialog-CreateNotificationRuleType-Select"
          name="ruleType"
          required
          v-model="data.ruleType"
          v-validate="{ rules: { required: true } }"
        >
          <el-option
            :key="type.key"
            :label="type.label"
            :value="type.value"
            v-for="type in ruleTypes"
          >
          </el-option>
        </el-select>
        <el-row :gutter="5" class="status-rule-block" v-if="isStatusRule">
          <el-col :span="8">
            <el-form-item :error="errors.has('key') ? errors.first('key') : ''" :show-message="false">
              <el-input
                :placeholder="$t('notificationsCreateInputKeyPlaceholder')"
                :data-vv-as="$t('notificationsCreateInputKeyPlaceholder')"
                clearable
                data-qa="Dialog-CreateNotificationRuleTypeConditionsKey-Input"
                name="key"
                required
                type="text"
                v-model="data.conditions.key"
                v-validate="{ rules: { required: true, regex: validate.deviceKey } }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :error="errors.has('operator') ? errors.first('operator') : ''" :show-message="false">
              <el-select
                :placeholder="$t('notificationsCreateInputOperatorPlaceholder')"
                :data-vv-as="$t('notificationsCreateInputOperatorPlaceholder')"
                data-qa="Dialog-CreateNotificationRuleTypeConditionsOperators-Select"
                name="operator"
                required
                v-model="data.conditions.op"
                v-validate="{ rules: { required: true } }"
              >
                <el-option
                  :key="op.key"
                  :label="op.label"
                  :value="op.value"
                  v-for="op in operators"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :error="errors.has('target') ? errors.first('target') : ''" :show-message="false">
              <el-input
                :placeholder="$t('notificationsCreateInputTargetPlaceholder')"
                :data-vv-as="$t('notificationsCreateInputTargetPlaceholder')"
                clearable
                data-qa="Dialog-CreateNotificationRuleTypeConditionsTarget-Input"
                name="target"
                required
                type="text"
                v-model="data.conditions.target"
                v-validate="{ rules: { required: true, numeric: true } }"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="help is-danger conditions-error" v-if="hasConditionsError">
          <p v-if="errors.has('key')">{{ $t('notificationsCreateInputKeyError') }}</p>
          <p v-if="errors.has('operator')">{{ errors.first('operator') }}</p>
          <p v-if="errors.has('target')">{{ errors.first('target') }}</p>
        </div>
      </el-form-item>
      <el-form-item
        :label-width="labelWidth"
        class="column-describe"
        data-qa="Dialog-CreateNotificationRuleType-Description"
      >
        <div class="fit-line-height">
          <i>{{ $t('notificationsCreateInputRuleTypeHint') }}</i>
        </div>
      </el-form-item>
      <el-form-item
        :error="errors.has('title') ? errors.first('title') : ''"
        :label="$t('notificationsCreateInputTitleLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('title')"
        data-qa="Dialog-CreateNotificationTitle-Item"
      >
        <el-input
          :placeholder="$t('notificationsCreateInputTitlePlaceholder')"
          :data-vv-as="$t('notificationsCreateInputTitleLabel')"
          clearable
          data-qa="Dialog-CreateNotificationTitle-Input"
          name="title"
          required
          type="text"
          v-model="data.title"
          v-validate="{ rules: { required: true, max: 40 } }"
        />
      </el-form-item>
      <el-form-item
        :label-width="labelWidth"
        class="column-describe"
        data-qa="Dialog-CreateNotificationTitle-Description"
      >
        <div class="fit-line-height">
          <i>{{ $t('notificationsCreateInputTitleHint1') }}</i><br />
          <i>{{ $t('notificationsCreateInputTitleHint2') }}</i>
        </div>
      </el-form-item>
      <el-form-item
        :error="errors.has('message') ? errors.first('message') : ''"
        :label="$t('notificationsCreateInputMessageLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('message')"
        data-qa="Dialog-CreateNotificationMessage-Item"
      >
        <el-input
          :placeholder="$t('notificationsCreateInputMessagePlaceholder')"
          :data-vv-as="$t('notificationsCreateInputMessageLabel')"
          clearable
          data-qa="Dialog-CreateNotificationMessage-Input"
          name="message"
          required
          type="text"
          v-model="data.message"
          v-validate="{ rules: { required: true, max: 160 } }"
        />
      </el-form-item>
      <el-form-item
        :label-width="labelWidth"
        class="column-describe"
        data-qa="Dialog-CreateNotificationMessage-Description"
      >
        <div class="fit-line-height">
          <i>{{ $t('notificationsCreateInputMessageHint1') }}</i><br />
          <i>{{ $t('notificationsCreateInputMessageHint2') }}</i>
        </div>
      </el-form-item>
    </el-form>
    <span slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-CreateNotification-Button-Close"
        type="text"
      >
        {{ $t('notificationsCreateDialogButtonCloseText') }}
      </el-button>
      <el-button
        @click="createNotification"
        :disabled="loading || errors.any()"
        :loading="loading"
        data-qa="Dialog-CreateNotification-Button-Save"
        type="warning"
      >
        {{ $t('notificationsCreateDialogButtonSaveText') }}
      </el-button>
    </span>
  </hamv-dialog>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal" v-else>
    <span class="el-dialog__title" data-qa="Dialog-CreateNotificationNoQuota-Title" slot="header">{{ $t('notificationsCreateTitleNoQuota') }}</span>
    <i18n path="notificationsCreateBodyNoQuota" data-qa="Dialog-CreateNotificationNoQuota-Text" tag="span">
      <a place="support" href="mailto:support@exosite.com">support</a>
    </i18n>
    <span slot="actions">
      <el-button
        @click="closePopup"
        data-qa="Dialog-CreateNotificationNoQuota-Button-OK"
        type="warning"
      >
        {{ $t('notificationsCreateDialogButtonOKText') }}
      </el-button>
    </span>
  </hamv-dialog>
</template>

<script>
  import main from './NotificationsCreate.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './NotificationsCreate.scss'
</style>



// WEBPACK FOOTER //
// NotificationsCreate.vue?f383402e